module.exports = __webpack_public_path__ + "img/gallery-icon-07.40d5d5ab.png";